export class FFTabNav extends HTMLElement {
	activeIndex = 0
	hasLabel = false
  DOM: {
    anchors: NodeListOf<HTMLElement>
    indicator: HTMLElement | null
  }

  constructor(){
    super();
    this.DOM = {
      anchors: this.querySelectorAll("button"),
      indicator: null
    }
		this.init()
		this.events()
  }

	events(){
		this.addEventListener("mouseleave", this.handleMouseleave.bind(this) );
		for (let i = 0; i < this.DOM.anchors.length; i++) {
			this.DOM.anchors[i].addEventListener("mouseenter", this.handleMouseenter.bind(this) );
			this.DOM.anchors[i].addEventListener("click", this.handleClick.bind(this) );
		}
	}

	init(){
		if (!this.DOM.anchors.length) return
		this.hasLabel = !!this.dataset.label
		const indicator = document.createElement("div")
		indicator.classList.add("indicator")
		this.DOM.indicator = indicator
		this.appendChild(indicator)
		this.setIndicatorTo(0)
	}

	setIndicatorTo(i: number){
		const anchor = this.DOM.anchors[i]
		if (!anchor || !this.DOM.indicator) return
		const rect = anchor.getBoundingClientRect()
		const width = rect.width
		const left = rect.left
		const parentLeft = this.getBoundingClientRect().left
		const newWidth = width - ( this.hasLabel || i > 0 ? 20 : 10 )
		const newLeft = left - parentLeft + ( this.hasLabel || i > 0 ? 10 : 0 )
		this.DOM.indicator!.style.width = `${newWidth}px`
    this.DOM.indicator!.style.transform = `translateX(${newLeft}px)`
	}

	handleMouseenter(e: MouseEvent){
		const targ = e.currentTarget
    if(!targ) return
		const index = [...this.DOM.anchors].indexOf(targ as HTMLElement)
		this.setIndicatorTo(index)
	}

	handleMouseleave(){
		this.setIndicatorTo(this.activeIndex)
	}

	handleClick(e: MouseEvent){
		const targ = e.currentTarget
    if(!targ) return
		const index = [...this.DOM.anchors].indexOf(targ as HTMLElement)
		this.setIndicatorTo(index)
		this.activeIndex = index
	}
}
customElements.define('ff-tab-nav', FFTabNav);